<style>
.SingleCurveTable .table__container--panel {
  background-color: #f5f7f7;
  color: #757575;
  border: 1px 1px 0px 1px solid #bdc3c7;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: rgb(189, 195, 199);
}
.SingleCurveTable .table__container--panel p {
  font-size: 12px;
}
.SingleCurveTable .table__container--separator {
  border-right: 1px solid rgba(189, 195, 199, 0.5);
  content: " ";
  height: 8px;
  margin-top: 8px;
  position: relative;
  right: 0;
  top: 0;
}
.SingleCurveTable .table__container--filter {
  margin: 3px;
  border: 1px solid rgba(189, 195, 199, 0.5);
  font-size: 12px;
}
.layout.SingleCurveTable.row.fill-height.wrap {
  height: 85%;
}
</style>

<template>
  <v-layout
    row
    fill-height
    wrap
    class="SingleCurveTable"
  >
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColDef"
      :stopEditingWhenGridLosesFocus="true"
    ></ag-grid-vue>
  </v-layout>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../../shared/ExportTableData";

export default {
  name: "App",
  props: {
    currentCurve: Object
  },
  data: () => ({
    tableTitle: "SingleCurveTable",
    columnDefs: [],
    dict: [],
    singleCurve: {},
    defaultColDef: undefined,
    editingEvent: undefined
  }),
  components: {
    AgGridVue,
    ExportTableData,
    Buttons: {
      template:
        '<span><v-icon small title="Usuń" @click="removeCurveValue">delete</v-icon></span>',
      methods: {
        removeCurveValue() {
          let curve = this.params.context.componentParent.currentCurve;
          let removedX = this.params.data.x;
          let removedY = this.params.data.y;

          for(let i in curve.data) {
            if(curve.data[i].x == removedX && curve.data[i].y == removedY) {
              curve.data.splice(i, 1);
              break;
            }
          }

          let payload = {
            oid: curve.id,
            body: {
              curve_id: curve.curve_id,
              curve_type: curve.curve_type,
              data: curve.data,
              description: curve.description
            }
          }

          this.$store.dispatch("editCurveValues", payload).then(r => {
            if(r) {
              this.params.context.componentParent.gridOptions.api.setRowData(curve.data);

              this.$root.$emit('loadCurve', curve);
              this.$root.$emit('computeChartData', false);
              this.isEdited = true;
            } else {
              this.$root.$emit(
                "showSnackbar",
                "red",
                `${r}`
              );
            }
          });
        },
      }
    }
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        rowData: [],
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        onFilterModified: this.filteredNumber,
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        onCellEditingStopped: this.editingStopped,
        context: {
          componentParent: this
        },
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
  },
  beforeMount() {
    this.dict = [
      {
        headerName: (this.currentCurve.curve_type == 0) ? "Czas" : "Flow",
        field: "x",
        width: 30
      },
      {
        headerName: (this.currentCurve.curve_type == 0) ? "Współczynnik" : ((this.currentCurve.data.length == 1 || this.currentCurve.data.length == 3) ? "Head" : "Efficiency"),
        field: "y",
        width: 30
      }
    ];
    this.defaultColDef = {
      editable: true
    };
    this.columnDefs = [
      {
        headerName: "",
        cellRendererFramework: "Buttons",
        minWidth: 30,
        width: 30
      }
    ];
    this.dict.forEach(field => {
      this.columnDefs.push(field);
    });
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    editingStopped(e) {
      let curve = this.currentCurve;
      curve.data[e.rowIndex] = e.data

      let payload = {
        oid: curve.id,
        body: {
          curve_id: curve.curve_id,
          curve_type: curve.curve_type,
          data: curve.data,
          description: curve.description
        }
      }

      this.$store.dispatch("editCurveValues", payload).then(r => {
        if(r) {
          this.gridOptions.api.setRowData(curve.data);
          this.$root.$emit('loadCurve', curve);
          this.$root.$emit('computeChartData', false);
          this.isEdited = true;
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            `${r}`
          );
        }
      });
    },
    showNoRowsMessage() {
      let dataSource = {
        getRows(params) {
          params.successCallback([], 0);
        }
      };
      this.gridOptions.api.setDatasource(dataSource);
      this.gridOptions.api.showNoRowsOverlay();
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      this.gridOptions.api.setRowData(this.currentCurve.data);
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
      this.gridOptions.api.sizeColumnsToFit();
    },
    createNewRow() {
      this.gridOptions.api.updateRowData({add: [{x: '', y: ''}]});
    }
  },
  mounted() {
    this.$root.$on('createNewRow', this.createNewRow)
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/curves/SingleCurveTable.vue